import { createAction } from "@reduxjs/toolkit";

const ACTION_PREFIX = "HEADER";

export const setPageNameHeader = createAction<string>(`${ACTION_PREFIX}/SET_PAGE_NAME`);
export const setOnSiteTeamMemberHeader = createAction<boolean>(`${ACTION_PREFIX}/SET_ON_SITE_TEAM_MEMBER_HEADER`);
